// my-loader.component.ts
import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { LoaderService } from '../../services/loader.service';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-my-loader',
  templateUrl: './my-loader.component.html',
  styleUrls: ['./my-loader.component.scss']
})
export class MyLoaderComponent implements OnInit, OnDestroy {

  loading: boolean = false;
  loadingMessage: string = 'Loading';
  private subscriptions: Subscription[] = [];

  constructor(private loaderService: LoaderService, private router: Router) { }

  ngOnInit() {
    this.initializeLoader();
  }

  ngOnDestroy() {
    // Clean up subscriptions to prevent memory leaks
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  private initializeLoader() {
    /** loader for http calls with custom messages */
    const httpLoaderSub = this.loaderService.loaderState.subscribe((state) => {
      this.loading = state.isLoading;
      if (state.message) {
        this.loadingMessage = state.message;
      }
    });

    /** loader for page navigation calls */
    const routerSub = this.router.events
      .pipe(
        filter(event =>
          event instanceof NavigationStart ||
          event instanceof NavigationEnd ||
          event instanceof NavigationCancel ||
          event instanceof NavigationError
        )
      )
      .subscribe((event) => {
        if (event instanceof NavigationStart) {
          // Only show navigation loader if no HTTP loader is active
          const currentState = this.loaderService.getState();
          if (!currentState.isLoading) {
            this.loading = true;
            this.loadingMessage = 'Loading page';
          }
        } else {
          // Only hide if this was a navigation loader (not HTTP loader)
          const currentState = this.loaderService.getState();
          if (!currentState.isLoading) {
            this.loading = false;
            this.loadingMessage = 'Loading';
          }
        }
      });

    this.subscriptions.push(httpLoaderSub, routerSub);
  }
}
